import { useEffect, useRef } from 'react';
import cn from 'classnames';
import styles from './Map.module.scss';

type MapProps = {
  className?: string;
  height?: number;
};

export function Map({ className, height }: MapProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const wrapperClassName = cn(styles.wrapper, className);

  useEffect(() => {
    if (!wrapperRef.current) return;

    const observer = new MutationObserver(() => {
      const canvas = wrapperRef.current?.querySelector('canvas');
      if (canvas) {
        // Переопределяем стили canvas
        canvas.style.aspectRatio = 'unset';
        canvas.style.height = '100%';
        canvas.style.width = '100%';
      }
    });

    observer.observe(wrapperRef.current, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={wrapperRef} className={wrapperClassName}>
      <iframe
        src="https://yandex.ru/map-widget/v1/?um=constructor%3A62525a6c81927dac36793d8214c2d87c032dcca1f73513890535347d9a74a2d1&source=constructor"
        width="100%"
        height={height}
        frameBorder="0"
        className={styles.map}
      />
    </div>
  );
}
